import i18n from "i18next";
import Backend from "i18next-xhr-backend";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { updateFontStyles } from "./shared/utils/fontConfig";

// Custom language detector that prioritizes URL path
const languageDetectorOptions = {
  // Order of detection:
  // 1. URL path (/en, /ar)
  // 2. localStorage
  // 3. navigator.language
  order: ["path", "localStorage", "navigator"],

  // Look for language code in the first path segment
  lookupFromPathIndex: 0,

  // Cache detected language in localStorage
  caches: ["localStorage"],
};

// Initialize i18next
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(Backend)
  .use(LanguageDetector)
  .init({
    resources: {
      en: {
        locales: require("./locales/en.json"),
      },
      ar: {
        locales: require("./locales/ar.json"),
      },
    },
    defaultNS: "locales",
    lng: localStorage.getItem("i18nextLng") || "en", // Check localStorage for saved language
    fallbackLng: "en", // Fallback to English if no language is set

    // Language detector options
    detection: languageDetectorOptions,

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    react: {
      useSuspense: false,
    },
  });

// Function to update the direction (LTR/RTL) of the page
const updatePageDirection = (lng: string) => {
  const html = document.documentElement;

  if (lng === "ar") {
    html.setAttribute("dir", "rtl"); // Set RTL for Arabic
  } else {
    html.setAttribute("dir", "ltr"); // Set LTR for English and others
  }
};

// Initialize the direction based on the initial language
updatePageDirection(i18n.language);

// Initialize the font styles based on the initial language
updateFontStyles();

// Save the selected language to localStorage whenever the language is changed
i18n.on("languageChanged", (lng) => {
  localStorage.setItem("i18nextLng", lng);
  updatePageDirection(lng); // Update the direction when the language is changed
  updateFontStyles(); // Update the font styles based on the language
});

export default i18n;
